import utils from 'services/utils'
import structure from './structure'

const menuItems = state => state.menu.items
const sidebarOpened = state => state.app.sidebar.opened
const toggleWithoutAnimation = state => state.app.sidebar.withoutAnimation
const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const breadcrumbs = state => {
  return (keyword) => {
    const route = utils.findInNestedByName(structure, keyword)
    if (route) {
      for (var i in route) {
        route[i].path = route[i].path.replace(':id', state.route.params.id)
      }
    }
    return route
  }
}

export {
  menuItems,
  toggleWithoutAnimation,
  sidebarOpened,
  config,
  palette,
  isLoading,
  breadcrumbs
}



// WEBPACK FOOTER //
// ./src/store/getters.js